import { ROUTES_CALENDAR, ROUTES_CREATE_SESSION, ROUTES_CREATE_EVENT } from '@/constants/routes';
import { LudumEventBus, RESET_SESSION_FORM } from '@/event-bus';
import { DAY_FORMAT_SHORT, DAY_MONTH_FORMAT, TIME_FORMAT_SHORT } from '@/constants/dateTimeFormats';

export default {
    methods: {
        sessionDate(session) {
            const dateFormat = `${DAY_FORMAT_SHORT} ${DAY_MONTH_FORMAT}`;
            const startDate = this.$options.filters.formatDateTime(session.start_date, dateFormat);
            const endDate = this.$options.filters.formatDateTime(session.end_date, dateFormat);
            return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
        },

        sessionTime(session) {
            const startDate = this.$options.filters.formatDateTime(session.start_date, TIME_FORMAT_SHORT);
            const endDate = this.$options.filters.formatDateTime(session.end_date, TIME_FORMAT_SHORT);
            return session.all_day_event ? this.$t('allDay') : `${startDate} - ${endDate}`;
        },

        openCreateSession() {
            LudumEventBus.$emit(RESET_SESSION_FORM);
            this.$router.push({ name: ROUTES_CREATE_SESSION });
        },

        openCreateEvent() {
            LudumEventBus.$emit(RESET_SESSION_FORM);
            this.$router.push({ name: ROUTES_CREATE_EVENT });
        },

        repeatSessionConfirmationRequired(response) {
            return (
                response.data &&
                response.data.has_question &&
                response.data.required &&
                response.data.required === 'repeat_update_type'
            );
        },

        changeSessionStructureConfirmationRequired(response) {
            return (
                response.data &&
                response.data.has_question &&
                response.data.required &&
                ['change_structure', 'change_seat_racing'].indexOf(response.data.required) > -1
            );
        },

        showChangeRepeatSessionConfirmationDialog(eventId, isSession = true, message, action = 'change') {
            const vm = this;
            const html = `<div>
                <h3>${message}</h3>
                <span id="swal-change-loading" style="display: none;"><div id="c_loading"><span class="c_loading__item"></span></div></span>
                ${this.createSwalButton(this.$t('allFutureEvents'), '#3085d6', 'swal-change-all-events')}
                ${this.createSwalButton(this.$t('onlyThisEvent'), '#f0ad4e', 'swal-change-only-this')}
                ${this.createSwalButton(this.$t('cancel'), '#aaa', 'swal-cancel')}
            </div>`;

            return this.$swal({
                title: '',
                html: html,
                type: 'warning',
                showConfirmButton: false,
                showCancelButton: false,
                onOpen() {
                    const loader = document.getElementById('swal-change-loading');

                    document.getElementById('swal-change-all-events').addEventListener('click', () => {
                        loader.classList.add('d-block');

                        if (action === 'delete') {
                            vm.deleteEvent(eventId, isSession, 'this_and_following').then(response => {
                                vm.$swal('', response.message, 'success').then(() => {
                                    vm.$router.push({ name: ROUTES_CALENDAR });
                                });
                            });
                        } else if (action === 'change') {
                            vm.repeatUpdateType = 'this_and_following';
                        }
                    });

                    document.getElementById('swal-change-only-this').addEventListener('click', () => {
                        loader.classList.add('d-block');

                        if (action === 'delete') {
                            vm.deleteEvent(eventId, isSession, 'this').then(response => {
                                vm.$swal('', response.message, 'success').then(() => {
                                    vm.$router.push({ name: ROUTES_CALENDAR });
                                });
                            });
                        } else if (action === 'change') {
                            vm.repeatUpdateType = 'this';
                        }
                    });

                    document.getElementById('swal-cancel').addEventListener('click', () => {
                        vm.$swal.close();
                    });
                }
            });
        },

        createSwalButton(text, btnColor, id) {
            return `<button id="${id}" class="btn" style="background-color: ${btnColor};"> ${text} </button>`;
        },

        deleteEvent(eventId, isSession = true, confirmed = false) {
            const data = {
                id: eventId
            };

            if (confirmed) {
                data.repeat_update_type = confirmed;
            }

            return this.$store.dispatch('post', {
                url: api + (isSession ? 'delete-session' : 'delete-event'),
                data: data
            });
        }
    }
};
